export const apiHost = {
    baseURL: "https://prod-ecs-mis.daqi.in/"
    // baseURL: "https://dev-mis-api.daqi.in/"
};